export const FETCH_DAILY_SLEEP_DATA_REPORTS = 'FETCH_DAILY_SLEEP_DATA_REPORTS';
export const FETCH_DAILY_SLEEP_DATA_REPORTS_FETCHING = 'FETCH_DAILY_SLEEP_DATA_REPORTS_FETCHING';
export const FETCH_DAILY_SLEEP_DATA_REPORTS_SUCCESS = 'FETCH_DAILY_SLEEP_DATA_REPORTS_SUCCESS';
export const FETCH_DAILY_SLEEP_DATA_REPORTS_FAIL = 'FETCH_DAILY_SLEEP_DATA_REPORTS_FAIL';

export const FETCH_WEEKLY_SLEEP_DATA_REPORTS = 'FETCH_WEEKLY_SLEEP_DATA_REPORTS';
export const FETCH_WEEKLY_SLEEP_DATA_REPORTS_FETCHING = 'FETCH_WEEKLY_SLEEP_DATA_REPORTS_FETCHING';
export const FETCH_WEEKLY_SLEEP_DATA_REPORTS_SUCCESS = 'FETCH_WEEKLY_SLEEP_DATA_REPORTS_SUCCESS';
export const FETCH_WEEKLY_SLEEP_DATA_REPORTS_FAIL = 'FETCH_WEEKLY_SLEEP_DATA_REPORTS_FAIL';
